class AboutSlider {
  constructor(root = document) {
    this.root = root;
    this.slider = this.root.querySelector('.about-slides');
    this.slides = this.root.querySelectorAll('.about-slide');
    
    // フェード機能の初期化
    this.fadeContainer = this.root.querySelector('.about-fade-container');
    this.fadeImages = this.root.querySelectorAll('.about-fade-image');
    
    if (!this.slider || !this.slides.length) return;

    // 多重初期化を防ぐ
    if (this.slider.dataset.initialized === 'true') return;
    this.slider.dataset.initialized = 'true';
    
    // フェード機能の初期化
    if (this.fadeContainer && this.fadeImages.length > 1) {
      this.initFadeSlider();
    }
    
    this.init();
  }
  
  init() {
    this.setupAutoScroll();
  }
  
  setupAutoScroll() {
    // 自動スクロール用に画像を複製
    const originalSlides = Array.from(this.slides);
    
    // 同じ画像セットを複製して追加（無限ループ用）
    originalSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('cloned');
      this.slider.appendChild(clone);
    });
    
    // CSS Animationで自動スクロール開始
    this.slider.classList.add('auto-scroll');
  }
  
  // フェード機能の初期化
  initFadeSlider() {
    this.fadeCurrentIndex = 0;
    this.fadeInterval = null;
    this.fadeAutoDelay = 4000; // 4秒間隔
    
    // タップでの画像切り替えイベント
    this.fadeContainer.addEventListener('click', () => {
      this.nextFadeImage();
      this.restartFadeAutoSlide();
    });
    
    // 自動切り替えを開始
    this.startFadeAutoSlide();
  }
  
  // 次のフェード画像に切り替え
  nextFadeImage() {
    if (this.fadeImages.length <= 1) return;
    
    // 現在のactive画像を非表示
    this.fadeImages[this.fadeCurrentIndex].classList.remove('active');
    
    // 次のインデックス
    this.fadeCurrentIndex = (this.fadeCurrentIndex + 1) % this.fadeImages.length;
    
    // 次の画像を表示
    this.fadeImages[this.fadeCurrentIndex].classList.add('active');
  }
  
  // 自動切り替えを開始
  startFadeAutoSlide() {
    if (this.fadeImages.length <= 1) return;
    
    this.fadeInterval = setInterval(() => {
      this.nextFadeImage();
    }, this.fadeAutoDelay);
  }
  
  // 自動切り替えを停止
  stopFadeAutoSlide() {
    if (this.fadeInterval) {
      clearInterval(this.fadeInterval);
      this.fadeInterval = null;
    }
  }
  
  // 自動切り替えを再開
  restartFadeAutoSlide() {
    this.stopFadeAutoSlide();
    this.startFadeAutoSlide();
  }
}

// Initialize helper
function initAboutSliderIn(root) {
  const sectionRoot = root?.querySelector ? root : document;
  const container = sectionRoot.querySelector('.about-slider-section') || sectionRoot;
  const sliderEl = container.querySelector('.about-slides');
  if (!sliderEl || sliderEl.dataset.initialized === 'true') return;
  new AboutSlider(container);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAboutSliderIn(document);
  });
} else {
  initAboutSliderIn(document);
}

// Re-initialize on Theme Editor section load
document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  if (target && target.querySelector('.about-slider-section')) {
    initAboutSliderIn(target);
  }
});